module.exports = __webpack_public_path__ + "static/img/7.99d0ea8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/cha/7.png
// module id = 7Nqd
// module chunks = 1